import React from "react";
import SidebarAds from "../Sidebars/SidebarAds";

const BG = "#050912";

const AdvertiserOnboardingLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: BG,
        color: "#e5e7eb",
      }}
    >
      <SidebarAds />

      <main
        style={{
          marginLeft: 200,
          width: "100%",
          padding: "32px",
          boxSizing: "border-box",
        }}
      >
        <div style={{ maxWidth: 820 }}>{children}</div>
      </main>
    </div>
  );
};

export default AdvertiserOnboardingLayout;
